import { arrayOf, func, object } from 'prop-types';
import React from 'react';

import FormDialog from '../../OnlineRehabilitation/components/FormDialog';
import StatusForm from '../../Status/components/StatusForm';

import QuestionBlock from './QuestionBlock';
import { path } from 'ramda';
import MSNQInfo from '../../Scores/components/MSNQInfo';
import FSMCInfo from '../../Scores/components/FSMCInfo';
import EQ5DForm from '../../QualityOfLife/components/EQ5DForm';
import FSMCForm from '../../Scores/components/FSMCForm';
import MSNQForm from '../../Scores/components/MSNQForm';
import calculateMSNQTotals from '../../Scores/calculateMSNQ';
import calculateFSMCTotals from '../../Scores/calculateFSMC';
import RehabHeader from './RehabHeader';
import normalize from 'lib/normalize';
import { AnswerItem } from './AnswerItem';

const Rehab1 = ({ fm, data, documents }) => {
  const msnqDoc = documents.find(d => d.documentId === data.msnq);
  const fsmcDoc = documents.find(d => d.documentId === data.fsmc);

  const [viewing, setViewing] = React.useState(null);

  const totalsDoc = type =>
    type === 'msnq'
      ? normalize(calculateMSNQTotals([msnqDoc]))[0]
      : type === 'fsmc'
        ? calculateFSMCTotals([fsmcDoc])[0]
        : null;

  const openDialog = (type, id, info = false) => {
    setViewing({ type, id, totals: info ? totalsDoc(type) : null });
  };

  const closeDialog = () => {
    setViewing(null);
  };

  return (
    <React.Fragment>
      <RehabHeader fm={fm} rehab={1} date={data.finished} />
      <QuestionBlock
        question={fm('npView.rehab1.status')}
        answer={data.status ? <AnswerItem type={'status'} id={data.status} openDialog={openDialog} /> : null}
      />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab1.2.h2')}
        answer={data.eq5d ? <AnswerItem type={'eq5d'} id={data.eq5d} openDialog={openDialog} /> : null}
      />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab1.3.h2')}
        answer={data.msnq ? <AnswerItem type={'msnq'} id={data.msnq} openDialog={openDialog} /> : null}
      />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab1.4.h2')}
        answer={data.fsmc ? <AnswerItem type={'fsmc'} id={data.fsmc} openDialog={openDialog} /> : null}
      />
      <FormDialog
        dialogOpen={!!viewing}
        type={path(['type'], viewing)}
        form={
          path(['type'], viewing) === 'status'
            ? StatusForm
            : path(['type'], viewing) === 'eq5d'
              ? EQ5DForm
              : path(['type'], viewing) === 'msnq'
                ? MSNQForm
                : path(['type'], viewing) === 'fsmc'
                  ? FSMCForm
                  : null
        }
        infoComponent={
          path(['totals'], viewing) && path(['type'], viewing) === 'msnq' ? (
            <MSNQInfo document={path(['totals'], viewing)} />
          ) : path(['totals'], viewing) && path(['type'], viewing) === 'fsmc' ? (
            <FSMCInfo document={path(['totals'], viewing)} />
          ) : null
        }
        documents={documents}
        viewingId={path(['id'], viewing)}
        closeCallback={closeDialog}
        fm={fm}
      />
    </React.Fragment>
  );
};

Rehab1.propTypes = {
  fm: func,
  data: object,
  documents: arrayOf(object),
};
export default Rehab1;
